import { QUERY_STAFF_SEARCH } from "../queries";
import { buildStaffByIdQuery } from "../queries/staff";
import type { PagedResult, SearchStaffOptions, Staff, StaffIncludeOptions } from "../types";
import { clampPerPage, validateId } from "../utils";
import type { ClientBase } from "./base";

/** @internal Fetch a staff member by AniList ID, optionally including media credits. */
export async function getStaff(client: ClientBase, id: number, include?: StaffIncludeOptions): Promise<Staff> {
  validateId(id, "staffId");
  const query = buildStaffByIdQuery(include);
  if (include?.characterRoles || include?.media) {
    const perPage = typeof include.media === "object" ? (include.media.perPage ?? 25) : 25;
    const data = await client.request<{ Staff: Staff }>(query, { id, perPage });
    return data.Staff;
  }
  const data = await client.request<{ Staff: Staff }>(query, { id });
  return data.Staff;
}

/** @internal Search for staff (voice actors, directors, etc.) by name. */
export async function searchStaff(client: ClientBase, options: SearchStaffOptions = {}): Promise<PagedResult<Staff>> {
  const { query: search, page = 1, perPage = 20, sort } = options;
  return client.pagedRequest<Staff>(
    QUERY_STAFF_SEARCH,
    { search, sort, page, perPage: clampPerPage(perPage) },
    "staff",
  );
}
